import { render, staticRenderFns } from "./HistoryCPPTNew.vue?vue&type=template&id=aa88ba2e&scoped=true"
import script from "./HistoryCPPTNew.vue?vue&type=script&lang=js"
export * from "./HistoryCPPTNew.vue?vue&type=script&lang=js"
import style0 from "./HistoryCPPTNew.vue?vue&type=style&index=0&id=aa88ba2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa88ba2e",
  null
  
)

export default component.exports